<div class="submitted-view" appBlockCopyPaste>
    <div class="submit-question-img">
        <img src="../../../assets/submit-answers.png" />
    </div>
    <div class="answered-qns-label">Your assessment has been expired. Thank you!</div>
</div>
